﻿/* globals ValorarAppDTO */
var jquery = require("jquery");

(function () {
	"use strict";

	var AppRating = function (ValorarAppDTO) {
	    this.__valorarAppDTO = ValorarAppDTO;
		this.__idBotonValorarSi = '#botonValorarSi';
		this.__idBotonValorarNo = '#botonValorarNo';
		this.__idEnviarComentario = '#enviarComentario';
        this.__idOpinion = '#valorarAppOpinion';
		this.__idBotonValorar = '#botonValorar';
		this.__$valorarAppSi = jQuery('#valorarAppSi');
		this.__$valorarAppNo = jQuery('#valorarAppNo');
		this.__$valorarAppFin = jQuery('#valorarAppFin');
		this.__$valorarAppInicio = jQuery('#valorarAppInicio');
	};

	var __registerEvents = function () {
		var self = this;
		jQuery(self.__idBotonValorarSi).click(function () {
			self.__$valorarAppInicio.addClass('ocultar');
			self.__$valorarAppSi.removeClass('ocultar');
		});

		jQuery(self.__idBotonValorarNo).click(function () {
			self.__$valorarAppInicio.addClass('ocultar');
			self.__$valorarAppNo.removeClass('ocultar');
		});

		jQuery(self.__idEnviarComentario).click(function () {
            var sOpinion = jquery(self.__idOpinion).val();
            if (sOpinion.length !== 0) {
		        self.__$valorarAppNo.addClass('ocultar');
                __valorarApp(self.__valorarAppDTO.urlValorarApp, sOpinion);
			    self.__$valorarAppFin.removeClass('ocultar');
            }
		});

		jQuery(self.__idBotonValorar).click(function () {
			self.__$valorarAppSi.addClass('ocultar');
			self.__$valorarAppFin.removeClass('ocultar');
		});
	};

	var __valorarApp = function (urlValorarApp, opinion) {
	    jquery.ajax({
	        url: urlValorarApp,
	        type: "POST",
	        data: { "opinion": opinion },
	        dataType: "json",
	        error: function (jqXHR, textStatus, errorThrown) {
	            var msg = "Error __callValorarApp: " + " responseText: " + jqXHR.responseText + " textStatus: " + textStatus + " errorThrown: " + errorThrown;
	            throw msg;
	        }
	    });
	};

	AppRating.prototype = {
		constructor: AppRating,
		RegisterEvents: __registerEvents,
	};

	if (typeof module !== 'undefined' && module.exports) {
	    module.exports = new AppRating(ValorarAppDTO);
	} else {
	    window.Utils = new AppRating(ValorarAppDTO);
	}
}());